import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import '../../styles/core.scss';
import css from './svg-icon.scss';

const SvgIcon = (props) => {
  const { icon } = props;
  const svg = icon ? (<Isvg src={icon} cacheGetRequests />) : '';
  return (
    <div {...props} className={css.svgIconComponent}>
      {svg}
    </div>
  );
};

SvgIcon.propTypes = {
  icon: PropTypes.string
};

export default styleable(css)(SvgIcon);
